export default {
  title: 'Financing file selection',
  search: 'Search agreements',
  expedient: 'Expedient',
  description: 'Agreement',
  amount: 'Advance payment available'
}
